import script from "./MakeupClassTable.vue?vue&type=script&setup=true&lang=js"
export * from "./MakeupClassTable.vue?vue&type=script&setup=true&lang=js"

import "./MakeupClassTable.vue?vue&type=style&index=0&id=3b8d966d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b8d966d"]])

export default __exports__